import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import PageHeader from "../../components/PageHeader/PageHeader";

import { getRegion } from "../../redux/actions/region.action";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action";
import { getGender } from "../../redux/actions/gender.action";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { Button, Form, Input, Select, DatePicker, Table, InputNumber, Spin } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";

import xlsx from "../../assets/images/ico_xls_sm.gif";

import { ReadCookie } from "../../utils/readCookie";
import { getStyle } from "../../redux/actions/style";
import { loadSalePerson } from "../../redux/actions/salePerson/salePersonForm.action";
import { getDefaultCompany } from "../../redux/actions/defaultCompany";
import { getCustomerType } from "../../redux/actions/customerType.action";
import { getOMSDetailReport } from "../../redux/actions/omsBookDetailReport.action";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { getSaleOrderFormData } from "../../redux/actions/salesOrder.action";
import { getAdminLocation } from '../../redux/actions/adminLocation.action';
import { SearchOutlined, FilterFilled } from '@ant-design/icons';
import numeral, { Numeral } from "numeral";
import { CSVLink } from "react-csv";
import { useLocation } from 'react-router-dom';
import { TabTitle } from "../../utils/GeneralFunction";
import { COMPANY_ID } from "../../utils/CompanyId";
import { getInternationalCustomer } from "../../redux/actions/internationalCustomer.action";
import { getInternationalPaymentTerm } from "../../redux/actions/internationalPaymentTerm.action";
import { getInternationalFreight } from "../../redux/actions/internationalFreight.action";
import { getInternationalCity } from "../../redux/actions/internationalCity.action";
import { getInternationalState } from "../../redux/actions/internationalState.action";
import { getInternationalCountry } from "../../redux/actions/internationalCountry.action";
import { getInternationalStyle } from "../../redux/actions/internationalStyle.action";
import { getInternationalWash } from "../../redux/actions/internationalWash.action";
import { getInternationalSalesContract } from "../../redux/actions/internationalSalesContract.action";
import { getInternationalRegion } from "../../redux/actions/internationalRegion.action";
import { getOMSIntPODSummaryReport } from "../../redux/actions/omsIntPODSummaryReport.action";
import { Get } from "../../utils/currency";
const { Option } = Select;


const OmsIntPODSummary = () => {
    TabTitle("Oms Int POD Summary")
    const [form] = Form.useForm();
    const [minimize, setMinimize] = useState(false);
    const [toogle, setToogle] = useState(false);
    const [loading, setLoading] = useState(false);
    const [bookDetailList, setBookDetailList] = useState([]);
    const dispatch = useDispatch();
    const tableRef = useRef(null);
    const menuId = ReadCookie("menuId");
    const token = ReadCookie("token");
    const { gender, region, style, salePersonForm, defaultCompany, paymentterm, customerTypes, omsIntPODSummaryReport, saleOrderFormData, adminLocation,
        // Int
        internationalCustomer,
        internationalPaymentTerm,
        internationalFreight,
        internationalCity,
        internationalState,
        internationalCountry,
        internationalStyle,
        internationalWash,
        internationalSalesContract,
        internationalRegion,
    } = useSelector((state) => state);
    const queryParams = new URLSearchParams(window.location.search);
    const customerID = queryParams.get("customer_id");
    const companyId = ReadCookie("defaultCompany");
    const [excelData, setExcelData] = useState([])
    const location = useLocation();
    const initialDate = moment('2024-01-01')
    const initialLastDate = moment('2026-12-31')



    useEffect(() => {
        dispatch(getGender(token, menuId));
        dispatch(loadSalePerson(token));
        dispatch(getSaleOrderFormData(token, companyId, menuId, "", customerID));
        // INT
        dispatch(getInternationalCustomer(token, menuId));
        dispatch(getInternationalPaymentTerm(token, menuId));
        dispatch(getInternationalFreight(token, menuId));
        dispatch(getInternationalCity(token, menuId));
        dispatch(getInternationalState(token));
        dispatch(getInternationalCountry(token));
        dispatch(getInternationalStyle(token));
        dispatch(getInternationalWash(token));
        dispatch(getInternationalSalesContract(token, menuId));
        dispatch(getInternationalRegion(token, menuId));
    }, [dispatch, menuId, token]);

    const BDCols = [
        {
            title: '#',
            dataIndex: '',
            // key: 'order_header_id',
            width: 50,
            render: (text, record, index) => {
                return index + 1;
            },
        },
        {
            title: 'Pick Ticket #',
            dataIndex: 'ship_header_no',
            key: 'ship_header_no',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.ship_header_no.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => {
                return a.ship_header_no - b.ship_header_no;
            },
        },
        {
            title: 'Ship Date ',
            dataIndex: 'ship_date',
            key: 'ship_date',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.ship_date.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => {
                return a.ship_date.localeCompare(b.ship_date);
            },
        },
        {
            title: 'Order #',
            dataIndex: 'order_header_no',
            key: 'order_header_id',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.order_header_no.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => {
                return a.order_header_no - b.order_header_no;
            },
            // render: (text, record) => (
            //     <Link style={{ color: "#0d6efd", textDecoration: "underline" }}
            //         to={"/sale-order?mode=edit&order_id=" + record.order_header_id + "/&customer_id/" + record.customer_id + "?edit=yes"}
            //     >
            //         {text}
            //     </Link>
            // ),
        },

        {
            title: "Customer",
            dataIndex: "customer_name",
            key: "customer_name",

            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.customer_name.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => a.customer_name.localeCompare(b.customer_name),
        },
        {
            title: "Billing Addressee",
            dataIndex: "billing_addressee",
            key: "billing_addressee",

            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.billing_addressee.toString().toLowerCase().includes(value.toLowerCase()),

            sorter: (a, b) => a.billing_addressee.localeCompare(b.billing_addressee),
        },


        {
            title: "PO #",
            dataIndex: "reference_no",
            key: "reference_no",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.reference_no.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => a.reference_no.localeCompare(b.reference_no),
        },
        {
            title: "Order Date",
            render: (text, record) => {
                return <>{moment(record.order_date).format("MM-DD-YY")}</>
            },
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.order_date.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => {
                return a.order_date.localeCompare(b.order_date);
            },
        },
        {
            title: "Start Date",
            render: (text, record) => {
                return <>{moment(record.start_date).format("MM-DD-YY")}</>
            },
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.start_date.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => {
                return a.start_date.localeCompare(b.start_date);
            },
        },
        {
            title: "Cancel Date",
            render: (text, record) => {
                return <>{moment(record.cancel_date).format("MM-DD-YY")}</>
            },
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.cancel_date.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => {
                return a.cancel_date.localeCompare(b.cancel_date);
            },
        },
        {
            title: 'Qty',
            dataIndex: "total_qty",
            key: 'total_qty',

            align: "right",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.total_qty.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => {
                return a.total_qty - b.total_qty;
            },
        },
        Get("currencycode"),
        {
            title: 'Amount',
            dataIndex: "amount",
            key: 'amount',

            align: "right",
            render: (text, record) => {
                return <> {numeral(record.amount).format('0,0.00')}</>
            },
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.amount.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => {
                return a.amount - b.amount;
            },
        },


        {
            title: 'Terms',
            dataIndex: "payment_term",
            key: 'payment_term',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.payment_term.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => a.payment_term.localeCompare(b.payment_term),
        },
        {
            title: 'Gender',
            dataIndex: 'gender_name',
            key: 'gender_name',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.gender_name.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => a.gender_name.localeCompare(b.gender_name),
        },
        {
            title: 'Sales Person',
            dataIndex: "salesperson_name",
            key: 'salesperson_name',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.salesperson_name.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => a.salesperson_name.localeCompare(b.salesperson_name),
        },
        {
            title: 'Region',
            dataIndex: "region_name",
            key: 'region_name',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.region_name.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => a.region_name.localeCompare(b.region_name),
        },
        {
            title: 'Country',
            dataIndex: "country",
            key: 'country',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.country.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => a.country.localeCompare(b.country),
        },
        {
            title: 'City',
            dataIndex: "city",
            key: 'city',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.city.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => a.city.localeCompare(b.city),
        },
        {
            title: 'State',
            dataIndex: "state",
            key: 'state',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.state.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => a.state.localeCompare(b.state),
        },
        {
            title: 'Zip',
            dataIndex: "zip_code",
            key: 'zip_code',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.zip_code.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => {
                return a.zip_code - b.zip_code;
            },
        },
        {
            title: 'Telephone',
            dataIndex: "phone",
            key: 'phone',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.phone.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => {
                return a.phone - b.phone;
            },
        },

        {
            title: 'Shipper',
            dataIndex: "shipper",
            key: 'shipper',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.shipper.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => a.shipper.localeCompare(b.shipper),
        },
        {
            title: 'Freight',
            dataIndex: "freightterm",
            key: 'freightterm',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => {
                return (
                    <>
                        <Input
                            autoFocus
                            allowClear
                            className='pop-search-gen pop-170'
                            placeholder="Type text here"
                            value={selectedKeys[0]}
                            onChange={(e) => {
                                setSelectedKeys(e.target.value ? [e.target.value] : []);
                                confirm({ closeDropdown: false });
                            }}
                            onPressEnter={() => {
                                confirm();
                            }}
                            onBlur={() => {
                                confirm();
                            }}
                        />
                    </>
                );
            },
            filterIcon: (filtered) =>
                filtered ? <FilterFilled /> : <SearchOutlined />,
            onFilter: (value, record) =>
                record.freightterm.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: (a, b) => a.freightterm.localeCompare(b.freightterm),
        },
    ];

    function downloadExcelFileData(data) {
        setExcelData(
            data.map((v) => {
                return {
                    "Pick Ticket #": v.ship_header_no,
                    "Ship Date #": v.ship_date,
                    "Order #": v.order_header_no,
                    "Customer": v.customer_name,
                    "Billing Addressee": v.billing_addressee,
                    "PO #": v.reference_no,
                    "Order Date": moment(v.order_date).format("MM-DD-YY"),
                    "Start Date": moment(v.start_date).format("MM-DD-YY"),
                    "Cancel Date": moment(v.cancel_date).format("MM-DD-YY"),
                    "Qty": v.total_qty,
                    "Currency": v.currencycode,
                    "Amount": parseFloat(v.amount).toFixed(2),
                    "Term": v.payment_term,
                    "Gender": v.gender_name,
                    "Sale person Name": v.salesperson_name,
                    "Region": v.region_name,
                    "Country": v.country,
                    "City": v.city,
                    "State": v.state,
                    "Zip": v.zip_code,
                    "Telephone": v.phone,
                    // "Fax": v.fax,
                    // "Email": v.email,
                    "Shipper": v.shipper,
                    "Freight": v.freightterm,
                };
            })
        )
    }






    const dateFormat = "MM-DD-YYYY";



    const onFinish = async () => {
        await form.validateFields().then((values) => {
            setLoading(true)
            dispatch(getOMSIntPODSummaryReport(token, values)).then((res) => {
                setToogle(true);
                setLoading(false)

                if (Array.isArray(res?.payload?.data)) {
                    setBookDetailList(res?.payload?.data);
                    downloadExcelFileData(res?.payload?.data);
                } else {
                    setBookDetailList([]);
                    alert("No valid data received.");
                }
            });
        })
    }

    const totalQuantity = () => {
        let sumQty = bookDetailList.reduce(function (previousValue, currentValue) {
            return previousValue += Number(currentValue.total_qty);
        }, 0);
        return sumQty;


    }

    const totalSum = () => {
        let sumAmount = bookDetailList.reduce(function (previousValue, currentValue) {
            return previousValue += Number(currentValue.amount);
        }, 0);
        return sumAmount;
    }

    return (
        <div className="styleContainer">
            <div className="styleBodyPendingSummary">
                <PageHeader
                    title={"Oms International POD Summary"}
                    minimize={setMinimize}
                    check={minimize}
                />
                {!minimize && (
                    <div className="bodyStyle">
                        <div className="formProduct p-0">
                            <Form onFinish={onFinish} form={form} name="control-hooks "
                            >
                                <div className="container-fluid pbpx-5 ptpx-5">
                                    <Brow>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div className="relative">
                                                    <Form.Item
                                                        name="from_date"
                                                        label="From Date:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        initialValue={initialDate}
                                                    >
                                                        <DatePicker
                                                            format={dateFormat}
                                                            size='small'
                                                            className="styleInput w-100"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div >
                                                <div className="relative">
                                                    <Form.Item
                                                        name="to_date"
                                                        label="To Date:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        initialValue={initialLastDate}
                                                    >
                                                        <DatePicker
                                                            size='small'
                                                            className="styleInput w-100"
                                                            format={"MM-DD-YYYY"}
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="order_no"
                                                        label="Order #"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        defaultValue={form.getFieldValue().order_no}
                                                    >
                                                        <InputNumber
                                                            size='small'
                                                            className="styleInput"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="ship_header_no"
                                                        label="Pick Ticket #"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        defaultValue={form.getFieldValue().order_no}
                                                    >
                                                        <InputNumber
                                                            size='small'
                                                            className="styleInput"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="customer"
                                                        label="Customer"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                        initialValue={"All"}
                                                    >
                                                        <Select
                                                            size='small'
                                                            showSearch
                                                            optionFilterProp="children"
                                                            filterSort={(optionA, optionB) =>
                                                                optionB?.value !== null ?
                                                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                            }
                                                            className="styleInput w-100"
                                                        >
                                                            <Option>All</Option>
                                                            {
                                                                Array.isArray(internationalCustomer?.payload?.data) &&
                                                                internationalCustomer.payload.data.map((val, index) => (
                                                                    <Option key={index} value={val.customer}>
                                                                        {val.customer}
                                                                    </Option>
                                                                ))
                                                            }

                                                        </Select>
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        {/* <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="billing_addressee"
                                                        label="Billing addressee"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <Input
                                                            size='small'
                                                            className="styleInput"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol> */}
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="po_no"
                                                        label="PO #"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <Input
                                                            size='small'
                                                            className="styleInput"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="country"
                                                    label="Country"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                    >
                                                        <Option>All</Option>
                                                        {
                                                            Array.isArray(internationalCountry?.payload?.data) &&
                                                            internationalCountry.payload.data.map((val) => (
                                                                <Option key={val.countryid} value={val.country}>
                                                                    {val.country}
                                                                </Option>
                                                            ))
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="region"
                                                    label="Region"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                    >
                                                        <Option>All</Option>
                                                        {
                                                            Array.isArray(internationalRegion?.payload?.data) &&
                                                            internationalRegion.payload.data.map((val) => (
                                                                <Option key={val.regionid} value={val.region}>
                                                                    {val.region}
                                                                </Option>
                                                            ))
                                                        }

                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="city"
                                                    label="City"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                    >
                                                        <Option>All</Option>
                                                        {
                                                            Array.isArray(internationalCity?.payload?.data) &&
                                                            internationalCity.payload.data.map((val) => (
                                                                <Option key={val.cityid} value={val.city}>
                                                                    {val.city}
                                                                </Option>
                                                            ))
                                                        }

                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="freight"
                                                    label="Freight"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                    >
                                                        <Option>All</Option>
                                                        {
                                                            Array.isArray(internationalFreight?.payload?.data) &&
                                                            internationalFreight.payload.data.map((val) => (
                                                                <Option key={val.freighttermid} value={val.freightterm}>
                                                                    {val.freightterm}
                                                                </Option>
                                                            ))
                                                        }

                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="payment_term"
                                                    label="Payment Term"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                    >
                                                        <Option>All</Option>
                                                        {
                                                            Array.isArray(internationalPaymentTerm?.payload?.data) &&
                                                            internationalPaymentTerm.payload.data.map((val) => (
                                                                <Option key={val.paymenttermid} value={val.paymentterm}>
                                                                    {val.paymentterm}
                                                                </Option>
                                                            ))
                                                        }

                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="state"
                                                    label="State"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                    >
                                                        <Option>All</Option>
                                                        {
                                                            Array.isArray(internationalState?.payload?.data) &&
                                                            internationalState.payload.data.map((val) => (
                                                                <Option key={val.stateid} value={val.state}>
                                                                    {val.state}
                                                                </Option>
                                                            ))
                                                        }

                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="style"
                                                    label="Style"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                    >
                                                        <Option>All</Option>
                                                        {
                                                            Array.isArray(internationalStyle?.payload?.data) &&
                                                            internationalStyle.payload.data.map((val) => (
                                                                <Option key={val.style} value={val.style}>
                                                                    {val.style}
                                                                </Option>
                                                            ))
                                                        }

                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="wash"
                                                    label="Wash"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                    >
                                                        <Option>All</Option>
                                                        {
                                                            Array.isArray(internationalWash?.payload?.data) &&
                                                            internationalWash.payload.data.map((val) => (
                                                                <Option key={val.washtype} value={val.washtype}>
                                                                    {val.washtype}
                                                                </Option>
                                                            ))
                                                        }

                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="salesContract"
                                                    label="Sales Contract"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterSort={(optionA, optionB) =>
                                                            optionB?.value !== null ?
                                                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                                        }
                                                        className="styleInput w-100"
                                                    >
                                                        <Option>All</Option>
                                                        {
                                                            Array.isArray(internationalSalesContract?.payload?.data) &&
                                                            internationalSalesContract.payload.data.map((val) => (
                                                                <Option key={val.spid} value={val.salescontact}>
                                                                    {val.salescontact}
                                                                </Option>
                                                            ))
                                                        }

                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="slc">
                                                <Form.Item
                                                    name="gender"
                                                    label="Gender"
                                                    labelAlign="left"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                    initialValue={"All"}
                                                >
                                                    <Select
                                                        size='small'
                                                        showSearch
                                                        optionFilterProp="children"
                                                        filterOption={(input, options) => options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                        className="styleInput w-100"
                                                    >
                                                        <Option >All</Option>
                                                        {
                                                            gender?.payload?.data.map((val) => {
                                                                return (
                                                                    <Option key={val.gender_name} value={val.gender_name}>{val.gender_name}</Option>
                                                                )
                                                            })
                                                        }

                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Bcol>

                                        {/*  */}
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="sku"
                                                        label="Sku #"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <Input
                                                            size='small'
                                                            className="styleInput"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="zip"
                                                        label="Zip"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <Input
                                                            size='small'
                                                            className="styleInput"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="shipper"
                                                        label="Shipper"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <Input
                                                            size='small'
                                                            className="styleInput"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol>
                                        {/* <Bcol lg={6} xl={4} xxl={3}>
                                            <div className="">
                                                <div >
                                                    <Form.Item
                                                        name="email"
                                                        label="Email"
                                                        labelAlign="left"
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <Input
                                                            size='small'
                                                            className="styleInput"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </Bcol> */}


                                    </Brow>
                                </div>
                            </Form>
                            <Button
                                htmlType="submit"
                                type="primary"
                                className="submit-btn-btm "
                                onClick={onFinish}
                            >
                                Submit
                            </Button>
                        </div>


                    </div>
                )}
            </div>
            <div style={{ marginTop: 10 }}>
                {
                    loading ? (
                        <div className=" report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-3">
                            <Spin size='large' />
                        </div>
                    ) : (bookDetailList.length > 0 ? (
                        < Table
                            title={() =>
                                <CSVLink
                                    filename={"Oms-International-Shipping-Summary.csv"}
                                    data={excelData}
                                    onClick={() => {

                                    }}
                                >
                                    Download Excel
                                </CSVLink>
                            }
                            ref={tableRef}
                            columns={BDCols}
                            loading={omsIntPODSummaryReport?.loading}
                            dataSource={omsIntPODSummaryReport?.payload?.data}
                            size="small"
                            rowKey={(record, index) => index}
                            footer={false}
                            bordered={false}
                            scroll={{ x: "max-content" }}
                            pagination={{
                                defaultCurrent: 1,
                                defaultPageSize: 100,
                                pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                            }}
                            summary={(pageData) => {


                                let Qty = pageData.reduce(function (
                                    previousValue,
                                    currentValue
                                ) {
                                    return (previousValue += parseFloat(
                                        currentValue.total_qty
                                    ));
                                },
                                    0);

                                let Amount = pageData.reduce(function (
                                    previousValue,
                                    currentValue
                                ) {
                                    return (previousValue += parseFloat(
                                        currentValue.amount
                                    ));
                                },
                                    0);

                                return (
                                    <>
                                        <Table.Summary.Row>
                                            <Table.Summary.Cell colSpan={3}>Total Quantity : {numeral(totalQuantity()).format("0,00,0")}
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>

                                            <Table.Summary.Cell>
                                                <p className="totalquantity aligntext">
                                                    {Qty.toLocaleString("en-US")}
                                                </p>
                                            </Table.Summary.Cell>
                                            <Table.Summary.Cell></Table.Summary.Cell>
                                            <Table.Summary.Cell>
                                                <p className="totalquantity aligntext">
                                                     {Amount.toLocaleString("en-US")}
                                                </p>
                                            </Table.Summary.Cell>

                                        </Table.Summary.Row>
                                        <Table.Summary.Row>
                                            <Table.Summary.Cell colSpan={3} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount :  {numeral(totalSum()).format("0,0.00")}
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </>
                                );
                            }}
                        />
                    ) : <div
                        style={{
                            backgroundColor: "#CCCCCC",
                            borderWidth: "1pt",
                            borderStyle: "Dashed",
                            fontWeight: "bold",
                            height: "25px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        No record(s)
                    </div>
                    )
                }
            </div>
        </div>
    )
}

export default OmsIntPODSummary;

